import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveOperadoraComponent } from '../../shared/components/SaveOperadoraComponent';

export interface CreateOperadoraPageProps {}

const CreateOperadoraPage: React.FC<CreateOperadoraPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_operadora);

  return <SaveOperadoraComponent title="Crear Operadora" />;
};

export default CreateOperadoraPage;
